function labelsonlineApp() {
    var app = this;
    app.endpoint = 'https://labelsonline-com.myshopify.com/api/2024-10/graphql.json';
    app.headers = {"X-Shopify-Storefront-Access-Token": "a87223acf2d4c59d73f95484844bf0af"};
    app.productData = {
        materials: [],
        prices: []
    };

    this.init = function () {
        app.events();
        app.categories();
        app.product();
    };

    this.product = function () {
        if(window.Product && window.Product.type) {
            if(window.Product.type === 'Labels - Laser') {
                app.getModels();
                $('.select-materials-container').on('change','select',function (e) {
                    var selectedHandle = $(this).val();
                    if(selectedHandle) {
                        var redirectUrl = window.location.origin + '/products/' + selectedHandle;
                        window.location.replace(redirectUrl);
                    }
                });
            } else if(window.Product.options.length === 1 && window.Product.options[0] === 'Quantity') {
                const tierPrices = [];
                window.Product.variants.forEach((variant, index) => {
                    tierPrices.push({
                        'id': variant.id,
                        'qty_min': parseInt(variant.title, 10),
                        'qty_max': typeof window.Product.variants[(index + 1)] !== 'undefined' ? parseInt(window.Product.variants[(index + 1)].title, 10) : 99999,
                        'price': this._formatCurrency(variant.price)
                    })
                });
                app.productData.prices = tierPrices;
                $('.product-form--atc').on('change','[data-quantity-input]',function (e) {
                    var priceContainer = $('.product-main .price--main .money'),
                        price = window.Product.priceMax,
                        variant = window.Product.variants[0],
                        inputValue = parseInt($(this).val(),10),
                        qty = isNaN(inputValue) || $(this).val().trim() === "" ? 1 : inputValue;
                    app.productData.prices.forEach((obj) => {
                        if(qty >= obj.qty_min && qty < obj.qty_max) {
                            priceContainer.text(obj.price);
                            $('select[name="id"]').val(obj.id);
                            $('select[name="id"]').trigger('change');
                            return false;
                        }
                    });
                });
            }
        }
    };

    this.getModels = function () {
        var model = (window.Product && window.Product.model) ? window.Product.model : null;
        if(model) {
            $.ajax({
                url: app.endpoint,
                method: 'POST',
                dataType: 'json',
                headers: app.headers,
                contentType: 'application/graphql',
                data: `query {
    products(first:50, query:"tag:'model:${model}'"){
        edges {
            node {
                title
                handle
                metafield(namespace: "labelsonline", key: "facestock-description") {
                    value
                }
            }
        }
    }
}`,
            })
                .done(function (response) {
                    if (response.data && response.data.products) {
                        app.productData.materials = response.data.products.edges;
                        app.updateMaterialDropdown();
                    }
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log(jqXHR.responseText);
                    console.log(textStatus);
                })
        }
    };

    this.updateMaterialDropdown = function () {
        if(app.productData.materials.length > 0) {
            var selectHtml = $('<select name="property[Material]" id="static-product-form-material" class="form-field-input form-field-select form-field-filled"></select>'),
                optionsHtml = '',
                topOption = '',
                parentEl = $('#select-materials-container');
            $.each(app.productData.materials,function (index,material) {
                var handle = material.node.handle,
                    value = material.node.metafield.value,
                    selected = '';
                selected = (window.Product && window.Product.handle === handle) ? ' selected="selected"':'';
                if(value.indexOf('Standard White Matte') > -1) {
                    topOption += '<option value="'+handle+'"'+selected+'>'+value+'</option>';
                } else {
                    optionsHtml += '<option value="'+handle+'"'+selected+'>'+value+'</option>';
                }
            });
            optionsHtml = topOption + optionsHtml;
            selectHtml.append(optionsHtml);
            parentEl.append(selectHtml);
            parentEl.append($('<label for="static-product-form-material" class="form-field-title">Select Material</label>'));
            parentEl.append($('<svg class="prefix__icon-chevron-down-small" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 6" width="8" height="6"><path class="prefix__icon-chevron-down-left" d="m4 4.5 3-3" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"/><path class="prefix__icon-chevron-down-right" d="m4 4.5-3-3" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"/></svg>'));
        }
    };

    this.events = function () {
        $('[data-filter-toggle]').on('click',function (e) {
            var state = $(this).data('filter-toggle');
            if(state && state === true) {
                $(this).closest('ul').prev('h3').addClass('open');
            } else {
                $(this).closest('ul').prev('h3').removeClass('open');
            }
        });
        $('[data-filter-title-toggle]').on('click',function (e) {
            $(this).next('ul').find('[data-filter-toggle]').trigger('click');
        });
    };

    this.categories = function () {
        var labelsperSheetFilters = $('.filter-item[data-group="Labels per Sheet"]'),
            parentEl,
            sortedFilters;
        if(labelsperSheetFilters.length > 0) {
            parentEl = labelsperSheetFilters.first().closest('ul');
            labelsperSheetFilters.detach().sort(function(a,b) {
                var valueA = parseInt($(a).data('handle').replace('labels-per-sheet_',''));
                var valueB = parseInt($(b).data('handle').replace('labels-per-sheet_',''));
                if(valueA<valueB) return -1;
                if(valueA>valueB) return 1;
                return 0;
            });
            parentEl.prepend(labelsperSheetFilters);
        }
    };

    this._formatCurrency = function(amount) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(amount/100);
    }
}

var lolApp = new labelsonlineApp();
lolApp.init();
